import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { ThemeProvider, useTheme } from "@/lib/theme";

const ThemedToaster = () => {
  const { theme } = useTheme();
  const style = theme === "light" ? { background: "#FFFFFF", border: "1px solid rgba(0,0,0,0.08)" } : { background: "#18181B", border: "1px solid rgba(255,255,255,0.08)" };
  return <Toaster position="top-center" theme={theme} richColors toastOptions={{ style }} />;
};
import { AuthProvider, useAuth, homeFor } from "@/lib/auth";
import { PositionsProvider } from "@/lib/positions";
import StaffLayout from "@/components/layout/StaffLayout";
import EmployeeLayout from "@/components/layout/EmployeeLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/admin/Dashboard";
import EventsList from "@/pages/admin/EventsList";
import EventForm from "@/pages/admin/EventForm";
import EventBoard from "@/pages/admin/EventBoard";
import DayBoard from "@/pages/admin/DayBoard";
import Employees from "@/pages/admin/Employees";
import Settings from "@/pages/admin/Settings";
import Available from "@/pages/employee/Available";
import Schedule from "@/pages/employee/Schedule";
import Profile from "@/pages/employee/Profile";
import Hours from "@/pages/employee/Hours";
import Timesheets from "@/pages/admin/Timesheets";

const Guard = ({ roles, children }) => {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-sm text-neutral-400">…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!roles.includes(user.role) && !(roles.includes("staff") && user.is_staff)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
};

const Home = () => {
  const { user, ready } = useAuth();
  if (!ready) return null;
  return <Navigate to={user ? homeFor(user.role) : "/login"} replace />;
};

function App() {
  return (
    <LangProvider>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <PositionsProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route element={<Guard roles={["admin"]}><StaffLayout /></Guard>}>
                <Route path="/admin" element={<Dashboard />} />
                <Route path="/admin/events" element={<EventsList />} />
                <Route path="/admin/events/new" element={<EventForm />} />
                <Route path="/admin/events/:id/edit" element={<EventForm />} />
                <Route path="/admin/events/:id" element={<EventBoard />} />
                <Route path="/admin/day" element={<DayBoard />} />
                <Route path="/admin/day/:date" element={<DayBoard />} />
                <Route path="/admin/employees" element={<Employees />} />
                <Route path="/admin/settings" element={<Settings />} />
                <Route path="/admin/timesheets" element={<Timesheets />} />
              </Route>
              <Route element={<Guard roles={["employee", "staff"]}><EmployeeLayout /></Guard>}>
                <Route path="/app" element={<Available />} />
                <Route path="/app/schedule" element={<Schedule />} />
                <Route path="/app/profile" element={<Profile />} />
                <Route path="/app/hours" element={<Hours />} />
              </Route>
              <Route path="*" element={<Home />} />
            </Routes>
            <ThemedToaster />
          </PositionsProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
    </LangProvider>
  );
}

export default App;
